import type { ReactNode } from 'react';

export interface WizardGuideStep {
  title: string;
  instruction: string;
  complete: boolean;
}

export function WizardGuideCard({ step, number, active, children }: {
  step: WizardGuideStep; number: number; active: boolean; children: ReactNode;
}) {
  return <section className={`wizard-guide-card${active ? ' wizard-guide-current' : ''}${step.complete ? ' wizard-guide-complete' : ''}`}
    aria-label={`${number}. ${step.title}`}>
    <div className="wizard-guide-heading">
      <h3>{number}. {step.title}</h3>
      <span className="wizard-guide-state">{step.complete ? 'Done' : active ? 'Current action' : 'To do'}</span>
    </div>
    <p className="wizard-guide-instruction">{step.instruction}</p>
    {children}
  </section>;
}

export function WizardNextAction({ steps, busy, error, ready, final = false, publicationUncertain = false }: {
  steps: WizardGuideStep[]; busy: boolean; error: string; ready: boolean; final?: boolean; publicationUncertain?: boolean;
}) {
  const current = steps.find(step => !step.complete);
  return <div className="wizard-next-action" role="status" aria-live="polite">
    <strong>{busy ? 'Checking / working...' : publicationUncertain ? 'Publication status uncertain' : error ? 'Needs attention' : ready ? 'Ready' : 'Next action'}</strong>
    <span>{busy ? 'Wait for the current check to finish. Your draft is retained.' :
      publicationUncertain ? 'Keep this wizard open and retry the unchanged publication with the same request identity. It may already have committed.' :
      error ? 'Resolve the reported issue below, then recheck. No changes have been published.' :
      ready ? final ? 'Inspect the visual roster, then choose Publish schedule when satisfied. Publication is never automatic.' :
        'Review the completed actions below, then choose Next.' :
        current?.instruction || 'Finish this tab and validate before continuing.'}</span>
  </div>;
}
